// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as loginReducer } from './login';
import { reducer as changeRoleReducer } from './changeRole';
import { reducer as changeUserNameReducer } from './changeUserName';
import { reducer as getCodeActionReducer } from './getCodeAction';
import { reducer as getCodeImageActionsReducer } from './getCodeImageActions';
import { reducer as loginActionsReducer } from './loginActions';

const reducers = [
  loginReducer,
  changeRoleReducer,
  changeUserNameReducer,
  getCodeActionReducer,
  getCodeImageActionsReducer,
  loginActionsReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    
    default:
        let name = sessionStorage.getItem("name");
        console.log("userName",name)
        newState = Object.assign({},state,{userName:name});
        break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/login/redux/reducer.js